import React from "react"
import PropTypes from "prop-types"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner, faImage } from '@fortawesome/free-solid-svg-icons'

class ProfilePictureSection extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      user: [],
      loaded: false,
      avatar_url: '',
      loading: false
    }
    this.onFileChange = this.onFileChange.bind(this)
    this.uploadImage = this.uploadImage.bind(this)
    this.fileInput = React.createRef() // ref to fileInput
    this.renderImage = this.renderImage.bind(this)
  }

  componentDidMount() {
    this.setState({
      avatar_url: this.props.user.avatar_url,
    })
  }

  uploadImage(image) {
    this.setState({
      loading: true
    })
    var formData = new FormData();
    formData.append('avatar', image, `${this.props.user.first_name}_${this.props.user.last_name}`);
    $.ajax({
      url: `../update_user_avatar`,
      dataType: 'JSON',
      type: 'POST',
      header: {
        'Content-Type': 'application/json'
      },
      processData: false,
      contentType: false,
      data: formData,
      success: (data) => {
        this.setState({
          avatar_url: data.data.avatar_url,
          loading: false
        })
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });
  }

  onFileChange(event) {
    let image = event.target.files[0]
    this.uploadImage(image)
  }

  triggerInputFile = () => {
      if (this.fileInput.current != undefined && this.fileInput.current.click != undefined)
          this.fileInput.current.click()
  }

  renderImage() {
    if(this.state.loading) {
      return(
        <div
          style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
          <FontAwesomeIcon
            icon={faSpinner}
            style={{color: 'white', fontSize: 20, marginBottom: 15, textAlign: 'center'}}
          />
          <h5 style={{color: 'white'}}>Loading</h5>
        </div>
      )
    } else {
      if(this.state.avatar_url != 'medium/missing.png') {
        return(
          <img
            style={{margin: 'auto', marginBottom: 20, width: 200, height: 200, borderRadius: 10}}
            src={this.state.avatar_url}  />
        )
      } else {
        return(<div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
          <FontAwesomeIcon
            icon={faImage}
            style={{color: 'white', fontSize: 30, marginBottom: 15, textAlign: 'center'}}
          />
          <h5 style={{color: 'white'}}>Show us your smile!</h5>
        </div>)
      }

    }

  }


  render () {
    return (
      <React.Fragment>
        <div style={{margin: 'auto', display: 'flex', flexDirection: 'column'}}>
            <div
              className="clickable"
              onClick={() => this.triggerInputFile()}
              style={{width: 200, display: 'flex', justifyContent: 'center', alignItems: 'center', height: 200, borderRadius: 10, backgroundColor: '#977DFF', margin: 'auto'}}>
                {this.renderImage()}
            </div>
            <button
                className="lightBlue clickable"
                style={{marginTop: 10}}
                onClick={() => this.triggerInputFile()}
            >
                {this.state.avatar_url === 'medium/missing.png' ? 'Add photo' : 'Change photo'}
            </button>
            <input
                ref={this.fileInput}
                type='file'
                hidden
                onChange={this.onFileChange}
            />
        </div>
      </React.Fragment>
    );
  }
}

export default ProfilePictureSection;
